import { Location } from '@angular/common';
import { AfterContentInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import { db } from 'src/app/db/db';
import { ETypeMaterielAdductionAir } from 'src/app/domain/Adduction-air/enum/type-materiel';
import { ETypePrelevementAir } from 'src/app/domain/Adduction-air/enum/type-prelevement-air';
import { MesureAdduction } from 'src/app/domain/Adduction-air/mesure-adduction';
import { PrelevementAir } from 'src/app/domain/Adduction-air/prelevement-air';
import { AdductionMaterielBoxDialog } from 'src/app/tools/ui/adduction-materiel-box/adduction-materiel-box';
import { AdductionPrelevementBoxDialog } from 'src/app/tools/ui/adduction-prelevement-box/adduction-prelevement-box';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import * as _ from 'lodash'
import { MaterielAdduction } from 'src/app/domain/Adduction-air/materiel-adduction';

@Component({
    selector: 'app-adduction',
    standalone: false,
    templateUrl: './adduction.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './adduction.component.scss'
})
export class AdductionComponent implements OnInit, AfterContentInit {
    // public TypeMaterielList: string[] = Object.values(ETypeMateriel)
    // .filter(x => !isNaN(Number(x)))
    // .map((x: any) => StringConverter.getTypeMaterielName(x));

    Model: MesureAdduction = new MesureAdduction();
    Date: Date = new Date();
    mrCode: string | undefined;

    constructor(
        private location: Location,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute) {

    }

    ngOnInit(): void {
        this.mrCode = this.route.snapshot.params?.['code'];
    }

    async ngAfterContentInit(): Promise<void> {
        if (!this.mrCode)
            return;
        this.Model = await db.getMesureAdductionByCodeWithChildren(this.mrCode);
    }

    getMockedData() {
        this.Model.Code = 'ADD0000003'
        this.Model.Date = Temporal.Now.plainDateISO(),
            // this.Model.AppareilMesure = 'Canne à peche'
            // this.Model.Localisation = "DTC"
            // this.Model.Observation = ''
            this.Model.SamplingID = 239784234
    }

    getPrelevementAdductionName(type: ETypePrelevementAir) {
        return StringConverter.getPrelevementAdductionName(type)
    }

    getMaterialName(type: ETypeMaterielAdductionAir) {
        return StringConverter.getTypeMaterielAdductionAirName(type)
    }

    dateChanged(event: MatDatepickerInputEvent<Date>) {
        if (!this.Model.Date) {
            return;
        }

        this.Model.Date = Temporal.PlainDate.from({ year: this.Date.getFullYear(), day: this.Date.getDate(), month: this.Date.getMonth() + 1 });
    }

    addMateriel() {
        if (this.Model.MaterielAdductionAirList.length >= 3) {
            NotificationManager.handleSuccess('Pas plus de 3 matériels', this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(AdductionMaterielBoxDialog, {
            data: {

            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.Model.MaterielAdductionAirList.push(result)
                NotificationManager.handleSuccess('Matériel ajouté', this.snackBar);
            }
        });
    }

    addPrelevement() {
        if (this.Model.PrelevementAirList.length >= 5) {
            NotificationManager.handleSuccess('Pas plus de 5 prélèvements', this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(AdductionPrelevementBoxDialog, {
            data: {

            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.Model.PrelevementAirList.push(result)
                NotificationManager.handleSuccess('Prélèvement ajouté', this.snackBar);
            }
        });
    }

    deletePrelevementAir(prel: PrelevementAir) {
        _.remove(this.Model.PrelevementAirList, prel);
    }

    deleteMateriel(mat: MaterielAdduction) {
        _.remove(this.Model.MaterielAdductionAirList, mat);
    }

    cancelMeasure() {
        const dialogRef = this.dialog.open(EditTextBoxDialog, { data: { title: 'Veuillez indiquer le motif de l\'annulation', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: string) => {
            if (result) {
                // TODO delete in DB
                await db.cancelAdduction(this.Model, result);
                NotificationManager.handleSuccess('Mesure annulée', this.snackBar);
                this.location.back()
            }
        })
    }

    async save() {
        const success = await db.updateMeasureAdduction(this.Model);
        if (success) {
            NotificationManager.handleSuccess('Mesure enregistrée', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }
}
